import { createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
export const CartDrawerContext = createContext(null);
export const useCartDrawer = () => {
  const context = useContext(CartDrawerContext);
  const navigate = useNavigate();
  return context || { openCart: () => navigate("/carrito") };
};
